export default [
  {
    path: '/data-management/:key?',
    name: 'data-management',
    component: () => import('@/views/system/dataManagement/DataManagementIndex.vue'),
    meta: {},
  },

  {
    path: '/data-management/create-data',
    name: 'create-data',
    component: () => import('@/views/system/dataManagement/CreateData.vue'),
    meta: {},
  },

  // Chuyển CHV theo dõi QĐ THA
  {
    path: '/transferExecutor',
    name: 'transferExecutor',
    component: () => import('@/views/dictionary/transferExecutor/TransferExecutor.vue'),
  },

  // Nhật ký truy cập
  {
    path: '/access-history',
    name: 'access-history',
    component: () => import('@/views/system/accessHistory/AccessHistory.vue'),
  },
  // Vai trò quyền hạn
  {
    path: '/role/:key?',
    name: 'role',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/system/role/RoleList.vue'),
    meta: {},
  },
  // Quản lý người dùng
  {
    path: '/usermanagement',
    name: 'usermanagement',
    component: () => import('@/views/system/usermanagement/UserManagementList.vue'),
    meta: {},
  },
  // Router tạo dữ liệu kế toán năm trước
  {
    path: '/data-management/create-data-prev-year',
    name: 'create-data-prev-year',
    component: () => import('@/views/system/dataManagement/createDataPrevYear/CreateDataPrevYear.vue'),
    meta: {},
  },
  {
    path: '/data-management/create-data-prev-year/create-data-process',
    name: 'create-data-process',
    component: () => import('@/views/system/dataManagement/createDataPrevYear/CreateDataPrevYearProcess.vue'),
    meta: {},
  },
  // Thiết lập chữ ký số
  {
    path: '/signing-setting',
    name: 'signing-setting',
    component: () => import('@/views/system/signingSetting/SigningSetting.vue'),
    meta: {},
  },
  // Thiết lập chữ ký số từ xa
  {
    path: '/esign-setting',
    name: 'esign-setting',
    component: () => import('@/views/system/esignSetting/EsignSetting.vue'),
    meta: {},
  },
];
